import React, { useContext } from 'react';

import { TNMIAddress, TNMIServicesRequired } from './types';
import { NMIResolutionState } from './NMIResolution';

interface NMIResolutionContext {
  addresses: TNMIAddress[];
  selectedFuel: TNMIServicesRequired;
  resolutionState: NMIResolutionState;
  handleResolutionStateChange: (resolutionState: NMIResolutionState) => void;
  showConfirmSuccess: boolean;
  setShowConfirmSuccess: (showConfirmSuccess: boolean) => void;
  showConfirmDialog: boolean;
  setShowConfirmDialog: (showConfirmDialog: boolean) => void;
  isEspec?: boolean;
  searchTerm?: string;
}

export const NMIResolutionContext = React.createContext<NMIResolutionContext | null>(null);

export function useNMIResolutionContext(component: string): NMIResolutionContext {
  const context = useContext(NMIResolutionContext);

  if (context === null) {
    throw new Error(
      `<NMIResolution.${component} /> is missing a parent <NMIResolution /> component.`
    );
  }

  return context;
}
